import { css } from "vite-css-in-js"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useIncidentHandler } from "../../IncidentLogHandler"
import AssetTaskedRow from "./AssetTaskedRow"

const tableStyles = css`
	grid-template-columns: minmax(auto, 2fr) 12rem repeat(6, minmax(auto, 1fr)) repeat(4, max-content);

	td,
	th {
		text-align: center;
		padding: 0.35rem 0.5rem;

		display: flex;
		align-items: center;
		justify-content: center;
		background-color: white;
	}

	tr > *:first-child {
		justify-content: start;
		text-align: left;
	}

	td:last-child,
	th:last-child {
		border: none !important;
		background-color: transparent;
	}

	td:last-child {
		padding: 0.25rem;
		button {
			padding: 0.375rem 0.5rem;
		}
	}
`

const AssetsTable: ReactiveComponent = () => {
	const handler = useIncidentHandler()

	return () => (
		<div class="w-full">
			{handler.incident.assetsTasked.length > 0 && <p class="mb-2">All times in the table below are in UTC.</p>}

			<table class={["grid-table", tableStyles]}>
				<thead>
					<tr>
						<th>SRU</th>
						<th>Crew</th>
						<th>Alerted</th>
						<th>Departed</th>
						<th>On Scene</th>
						<th>Returning</th>
						<th>Pier Heads</th>
						<th>Back on Station</th>
						<th>
							Tasking
							<br />
							Instructions
						</th>
						<th>
							Search <br /> Pattern
						</th>
						<th>
							Additional
							<br />
							Notes
						</th>
						<th />
					</tr>
				</thead>
				<tbody>
					{handler.incident.assetsTasked.map((asset) => (
						<AssetTaskedRow key={asset.id} asset={asset} />
					))}
				</tbody>
			</table>
		</div>
	)
}

export default defineComponent(AssetsTable)
